module.exports = __webpack_public_path__ + "static/media/photo-2-1-m.5274072b.jpeg";